import psychiatryQuestionSet from "../faq/psychiatryQuestionSet";

export const psychiatryAdult = {
    'meta': {
        'title': 'Psychiatra #city# - konsultacje osób dorosłych • Centrum COLLIGO',
        'description': 'Psychiatra #city#. Konsultacje psychiatryczne w naszym centrum prowadzone są przez doświadczonych lekarzy specjalistów w dziedzinie psychiatrii. Krótkie terminy, bezpieczna przestrzeń.'
    },
    'price': {
        'torun': {
            'first': 320,
            'next': 260
        },
        'bydgoszcz': {
            'first': 230,
            'next': 200
        }
    },
    'availability': [
        'torun',
        'bydgoszcz',
    ],
    'url': {
        'address': '#cityIdUrl#/uslugi/psychiatra-#cityIdUrlDash#konsultacje-osob-doroslych/',
        'title': 'Psychiatra osób dorosłych #cityLocativeIn#',
        'name': 'Konsultacje psychiatryczne osób dorosłych #cityLocativeIn#',
        'heading': 'Psychiatra #city# - konsultacje osób dorosłych',
        'fullName': 'Konsultacje psychiatryczne osób dorosłych'
    },
    'image': {
        'url': '/images/services/psychiatra-konsultacje-osób-doroslych.webp',
        'width': 886,
        'height': 295,
        'alt': 'Psychiatra osób dorosłych #cityLocativeIn#'
    },
    'opengraph': {
        'image': {
            'url': '/images/services/psychiatra-konsultacje-osób-doroslych.webp',
            'width': 886,
            'height': 295,
            'alt': 'Psychiatra osób dorosłych #cityLocativeIn#'
        }
    },
    'faq': psychiatryQuestionSet
}